import { Tag, Typography } from "antd";
import { buildFeishuMediaProxyUrl } from "../../../shared/feishuCellValue";

const { Text } = Typography;

export interface ScriptSheetCellContentProps {
  text?: string;
  imageFileToken?: string;
  imageUnderstanding?: string;
  maxImageSize?: number;
}

export function ScriptSheetCellContent({
  text,
  imageFileToken,
  imageUnderstanding,
  maxImageSize = 160,
}: ScriptSheetCellContentProps) {
  const trimmedText = text?.trim();

  if (!imageFileToken && !trimmedText) {
    return <>—</>;
  }

  return (
    <div>
      {imageFileToken ? (
        <img
          src={buildFeishuMediaProxyUrl(imageFileToken)}
          alt=""
          loading="lazy"
          style={{
            display: "block",
            maxWidth: maxImageSize,
            maxHeight: maxImageSize,
            objectFit: "contain",
            borderRadius: 4,
            marginBottom: trimmedText || imageUnderstanding ? 6 : 0,
          }}
        />
      ) : null}
      {trimmedText ? (
        <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{trimmedText}</span>
      ) : null}
      {imageUnderstanding?.trim() ? (
        <div style={{ marginTop: 6, fontSize: 12, color: "#64748b", lineHeight: 1.5 }}>
          <Tag color="blue" style={{ marginRight: 4 }}>
            已理解
          </Tag>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {imageUnderstanding.length > 120
              ? `${imageUnderstanding.slice(0, 120)}…`
              : imageUnderstanding}
          </Text>
        </div>
      ) : null}
    </div>
  );
}
